// src/utils/listCache.js
//
// Persists the last-known gallery/barber list (including resolved image
// URLs) in localStorage so a returning visitor's homepage can paint with
// last-known images instantly, instead of a generic placeholder, while a
// fresh Firestore read resolves in the background.

const PREFIX = "listCache:";

export function getCachedList(key) {
  try {
    const raw = localStorage.getItem(PREFIX + key);
    return raw ? JSON.parse(raw) : null;
  } catch (error) {
    return null;
  }
}

export function setCachedList(key, list) {
  try {
    localStorage.setItem(PREFIX + key, JSON.stringify(list));
  } catch (error) {
    // Ignore quota/availability errors; caching is a best-effort optimization.
  }
}
